import React from 'react';
import { RouteUtil } from 'utils/RouteUtil';
import './styles.scss';

const FooterLink = props => {
  const { link, prop } = props;
  const onUrlClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (redirectionURl) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(prop, redirectionURl);
      } else {
        window.open(`${redirectionURl}`);
      }
    }
  };

  return (
    <div className={'main-footer-link'}>
      {link.map((item, idx) => {
        return (
          <a onClick={() => onUrlClick(item.url)}>
            <strong> {item.title} </strong>
          </a>
        );
      })}
    </div>
  );
};
export default FooterLink;
